/**
 * 皮肤
 * @description 精灵的外观标识，由 id 与 name 唯一确定。
 * 皮肤的 id 与 swf / 头像等资源文件一一对应。
 * 一只精灵可拥有多个皮肤（Skin 数组），其中 id 等于精灵序号的皮肤为默认皮肤。
 */
export class Skin {
    /**
     * @param id 皮肤 ID（对应资源文件名）
     * @param name 皮肤名称
     */
    constructor(
        private _id: number,
        private _name: string
    ) {}

    /** 皮肤 ID */
    get id() {
        return this._id;
    }

    /** 皮肤名称 */
    get name() {
        return this._name;
    }

    /**
     * 更新当前name。
     * @param value 待处理的值
     */
    set name(value: string) {
        this._name = value;
    }

    /**
     * 获取皮肤头像图片 URL
     * @returns 返回皮肤头像图片的完整 URL 地址
     */
    getHeadImgUrl() {
        // return `https://seerh5.61.com/resource/assets/pet/head/${this._id}.png`;
        return `https://newseer.61.com/web/monster/head/${this._id}.png`;
    }

    /**
     * 获取皮肤战斗动画资源 URL
     * 使用经 ffdec 补丁后的本地 swf（帧标签提升到根时间轴，
     * 使 Ruffle 的 gotoAndStop 可直达 stand/attack/sa/cp 动画）。
     * @returns swf 格式的动画资源 URL
     */
    getBattleAnimUrl() {
        return `https://seer.61.com/resource/fightResource/pet/swf/${this._id}.swf`;
        // return `/pet_swf/${this._id}.swf`;
    }
}
